import { LabMDM } from "./lab";
import { OperetionHistoryDTO } from "./operationHistory";

//this model is used to define the workflow details

export class WorkFlow{
    
    _id: string;
    
    workFlowName:string;

    workflowGroup:string;

    processScale:string;

    mergeInStatus: string;

    statusAfterMerge: string;

	/** stores if the boolean value is active or not */
    active:boolean;

    /** lab associated with the workflow */
    lab:LabMDM;

    version: string;
    
    history:OperetionHistoryDTO[];

}